<template>
    <el-container>
        <el-header>
            <el-form style="width:100%;padding-top: 10px;">
                <el-row type="flex" class="row-bg" justify="space-between">
                  <query-log-gather  :is-input="false" :is-query="true" :is-reset="true" :is-date="true"  :isDate="true"
                                 :select-options ="czlxoptions"
                                 :cur-select-tip="curSelectTip"
                                 @qgQueryDeal="getRzxxPage_"
                                @qgResetDeal="reset"></query-log-gather>
                </el-row>
            </el-form>
        </el-header>
        <el-main style="padding-left: 15px;padding-right:15px;padding-bottom: 10px;">
          <div style="background-color: #ffffff;padding-left: 5px;padding-right:5px;height: 100%;position: relative;">
            <el-table
                :data="tableData"
                height="calc(100% - 60px)"
                max-height="calc(100% - 60px)"
                style="width:100%;padding: 5px;"
                @selection-change="handleSelectionChange"
                border
                @sort-change="sortChange"
                :row-style="tableRowClassName"
                :header-cell-style="{backgroundColor:'#f9f9ff',fontSize: '1.4rem',textAlign:'center',color:'#323232',
                          fontFamily:'PingFang SC',fontWeight:'normal',fontStretch:'normal',height:'6.5vh'}"
            >
                <el-table-column prop="addtime"  sortable="custom" label="操作时间" align="center" />
                <el-table-column prop="adduser" label="操作用户" align="center" />
              <el-table-column prop="clienttypeCode" label="客户端" align="center" >
                <template #header>
                  <span>客户端</span>
                  <el-popover
                      placement="bottom"
                      trigger="click"
                      width="200">
                    <el-select v-model="clienttype" style="margin-right: 10px;" placeholder="客户端类型" @change="resSelectCg">
                      <el-option

                          v-for="item in clienttypeList"
                          :key="item.code"
                          :label="item.name"
                          :value="item.code">
                      </el-option>
                    </el-select>
                    <el-row style="margin-top: 2vh;">
                      <el-col :span="12">
                        <el-button class="dgClose" @click="query">筛 选</el-button>
                      </el-col>
                      <el-col :span="12">
                        <el-button class="dgSave" @click="clientTypeReset">重 置</el-button>
                      </el-col>
                    </el-row>
                    <i slot="reference" class="el-icon-sxld"></i>
                  </el-popover>
                </template>
              </el-table-column>
                <el-table-column prop="ip" label="IP地址" align="center"  />
              <el-table-column prop="optypeCode" label="操作类型" align="center">
                <template #header>
                  <span>操作类型</span>
                  <el-popover
                      placement="bottom"
                      trigger="click"
                      width="200">
                    <el-select v-model="optype" style="margin-right: 10px;" placeholder="操作类型" @change="resSelectCg">
                      <el-option
                          v-for="item in optypeList"
                          :key="item.code"
                          :label="item.name"
                          :value="item.code">
                      </el-option>
                    </el-select>
                    <el-row style="margin-top: 2vh;">
                      <el-col :span="12">
<!--                        <el-button class="dgClose" @click="query">筛 选</el-button>-->
                      </el-col>
                      <el-col :span="12">
                        <el-button class="dgSave" @click="optypeReset">重 置</el-button>
                      </el-col>
                    </el-row>
                    <i slot="reference" class="el-icon-sxld"></i>
                  </el-popover>
                </template>
              </el-table-column>
                <el-table-column prop="opcontent" label="操作内容" align="left" width="550"/>
              <el-table-column prop="resName" label="所属水库" align="center">
                <template #header>
                  <span>所属水库</span>
                  <el-popover
                      placement="bottom"
                      trigger="click"
                      width="200">
                    <el-select v-model="rescdSort" style="margin-right: 10px;" placeholder="所属水库"  @change="resSelectCg">
                      <el-option
                          v-for="item in rescdList"
                          :key="item.rescd"
                          :label="item.resName"
                          :value="item.rescd">
                      </el-option>
                    </el-select>
                    <el-row style="margin-top: 2vh;">
                      <el-col :span="12">
<!--                        <el-button class="dgClose" @click="query">筛 选</el-button>-->
                      </el-col>
                      <el-col :span="12">
                        <el-button class="dgSave" @click="rescdSortReset">重 置</el-button>
                      </el-col>
                    </el-row>
                    <i slot="reference" class="el-icon-sxld"></i>
                  </el-popover>
                </template>
              </el-table-column>
            </el-table>
            <div style="width:100%;position: absolute;bottom: 10px;margin-top: 5px">
              <pageFooter @current-change="handleCurrentChange" @size-change="handleSizeChange" :rForm="params"></pageFooter>
            </div>
          </div>
        </el-main>
    </el-container>
</template>

<script>
import QueryLogGather from "./open/queryLogGather.vue"
import pageFooter from "@/components/pageFooter.vue";
export default {
name: "log",
components: {
  pageFooter,
  QueryLogGather
},
data() {
  return {
    pickerOptions: {
      shortcuts: [{
        text: '最近一周',
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit('pick', [start, end]);
        }
      }, {
        text: '最近一个月',
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          picker.$emit('pick', [start, end]);
        }
      }, {
        text: '最近三个月',
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          picker.$emit('pick', [start, end]);
        }
      }]
    },
    curSelectTip:'请选择操作类型查询',
    defaultDate: [],
    tableData: [],
    multiple: true,
    clienttype:'',
    optype:'',
    rescdSort:'',
    rescdList:'',
    optypeList:[],
    clienttypeList:[],
    params: {
      total: 1,
      size: 20,
      current: 1,
      addtimeGE:'',
      addtimeLE:'',
      optypeCode:'',
      clienttypeCode:'',
      sortCol:'',
      rescd:'',
      order:'descending'
    },
    czlxoptions: [],
    czlxValue: '',
    multipleSelection: [],
      stHeight:0,
  }
},
mounted() {
  this.getClientType();
  this.getOpType();
  this.getRescdList();
  this.getRzxxPage();
},
methods: {
  resSelectCg(){
    this.getRzxxPage_()
  },
  sortChange({ prop, order }) {
    //console.log('order',order)
    this.params.sortCol = prop;
    this.params.order = order;
    this.params.current = 1;
    this.getRzxxPage();
  },
  query(){
    this.params.current =1;
    this.getRzxxPage();
  },
  //重置筛选
  clientTypeReset(){
    this.clienttype ='';
    this.getRzxxPage();
  },
  optypeReset(){
    this.optype ='';
    this.getRzxxPage();
  },
  rescdSortReset(){
    this.rescdSort ='';
    this.getRzxxPage();
  },
  //获取操作类型
  getOpType(){
    this.request.get('/rm-sdictionary/v1/query/'+ '01').then(
        (res) => {
          if (res.ok) {
            this.optypeList = res.data;
          } else {
            this.$message({
              message: res.error.message,
              type: 'error',
              duration: 3000, //显示时间 <=0：永久显示,1000：1s
            });
          }
        }
    );
  },
  //获取客户端类型
  getClientType(){
    this.request.get('/rm-sdictionary/v1/query/'+ '02').then(
        (res) => {
          if (res.ok) {
            this.clienttypeList = res.data;
          } else {
            this.$message({
              message: res.error.message,
              type: 'error',
              duration: 3000, //显示时间 <=0：永久显示,1000：1s
            });
          }
        }
    );
  },
  //获取所属水库
  getRescdList(){
    this.request.get('/rm-bres/v1/query/login').then(
        (res) => {
          if (res.ok) {
            this.rescdList = res.data;
          } else {
            this.$message({
              message: res.error.message,
              type: 'error',
              duration: 3000, //显示时间 <=0：永久显示,1000：1s
            });
          }
        }
    );
  },
  tableRowClassName({row, rowIndex}) {
    return {
      height: '5.83vh',
    };
  },
  getRzxxPage_(par){
    this.params.current =1;
    this.getRzxxPage(par);
  },
  getRzxxPage(par) {
    let orderRange = 0;
    if(this.params.order ==="ascending"){
      orderRange = 0;
    }else if(this.params.order ==="descending"){
      orderRange = 1;
    }
    const parm =   {
      total: this.params.total,
      size: this.params.size,
      current: this.params.current,
      rescd:this.rescdSort,
      addtimeGE:this.defaultDate[0],
      addtimeLE:this.defaultDate[1],
      optypeCode:this.optype,
      clienttypeCode:this.clienttype,
      sortCol:this.params.sortCol,
      order:orderRange,
    }
  if(typeof par !="undefined"){
    parm.addtimeGE = par.curSelectDate[0];
    let end = new Date(par.curSelectDate[1]);
    end.setDate(end.getDate() + 1)
    let endDate = end.toISOString().slice(0, 10)
    parm.addtimeLE = endDate;
    this.defaultDate[0] = par.curSelectDate[0];
    this.defaultDate[1] = endDate;
  }
    this.request.get("/rm-slog/v1/pageList", {params: parm}).then(res => {
      if (res.ok) {
        this.tableData = res.data.records;
        this.params.total = res.data.total;
        this.params.size = res.data.size;
      }
    })
  },
  getCzlx(){
    this.request.get("/rm-sdictionary/v1/query/01").then(res => {
      if (res.ok) {
        this.czlxoptions = res.data
      }
    })
  },
  //切换size
  handleSizeChange(val) {
      this.params.size = val;
      this.params.current = 1
      this.getRzxxPage();
  },
    //切换页码
  handleCurrentChange(val) {
    this.params.current = val;
    this.getRzxxPage();
  },

  reset(){
    // this.$set(this.defaultDate,0,new Date().getTime() - 3600 * 1000 * 24)
    // this.$set(this.defaultDate,1,new Date)
    this.params.total=1,
    this.params.size=20,
    this.params.current=1,
    // this.params.addtimeGE =new Date().getTime() - 3600 * 1000 * 24,
    // this.params.addtimeLE = new Date().getTime(),

    this.czlxValue = ''
    this.params.optypeCode = "";

    this.getRzxxPage();
  },
  handleSelectionChange(val) {
    this.multiple = !val.length;
    this.multipleSelection = val;
  }
},
created() {
  this.getRzxxPage();
  this.getCzlx();
    let windowHeight = document.documentElement.clientHeight || document.bodyclientHeight;
    this.stHeight = windowHeight - 260;
}
}
</script>
<style scoped lang="less">
    ::v-deep .el-main {
      display: block;
      flex: 1;
      flex-basis: auto;
      overflow: auto;
      box-sizing: border-box;
      padding: 10px;
    }
    /deep/ .mydelete{
        background: url('~@/assets/images/delete.png') center no-repeat;
        /* background-size: cover;*/
    }

    .lightgreen-box {
        background-color: lightgreen;
        height: 24px;
    }

    .orange-box {
        background-color: orange;
        height: 24px;
    }
    .pl10{
      padding-left: 10px;
    }

    .el-icon-sxld {
      width: 10px;
      height: 9px;
      margin-left: 10px;
      cursor: pointer;
      background: url('../../assets/icons/sxld.png');
    }

    .dgClose {
      width: 8vh;
      height: 3vh;
      font-family: PingFang SC;
      font-size: 1.2vh;
      font-weight: normal;
      font-stretch: normal;
      line-height: 3vh;
      letter-spacing: 0vh;
      color: #0066ff;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border: solid 1px #53abfd;
      border-radius: 2px;
    }

    .dgSave {
      width: 8vh;
      height: 3vh;
      background-color: #53abfd;
      border-radius: 0vh;
      font-family: PingFang SC;
      font-size: 1.2vh;
      font-weight: normal;
      font-stretch: normal;
      line-height: 3vh;
      letter-spacing: 0vh;
      color: #ffffff;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border-radius: 2px;
    }
</style>
